"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.web.js';

var _excluded = ["children"];
var Icon = function Icon(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    tag: "span",
    "data-testid": "elemental-Icon",
    lineHeight: 1,
    display: "inline-flex",
    alignItems: "center"
  }, props), children);
};

export { Icon };
